import { canOpenReturn } from "../lib/unique-return.lib";
import { usePublicShop } from "../queries/use-public-shop";
import { useReturnRequests } from "../queries/use-return-requests";
import { useIsMerchant } from "./use-is-merchant";
import { useWidgetParams } from "./use-widget-params";

/**
 * Whether the person browsing may start a return on the current order. Stays
 * true while the returns of the order are loading, so the creation flow only
 * closes on an answer from the API.
 */
export function useCanOpenReturn(): boolean {
  const { shopId, orderId, shopSlug } = useWidgetParams();
  const { data: shop } = usePublicShop(shopId);
  const { data: returnRequestsData } = useReturnRequests({ orderId, shopSlug });
  const isMerchant = useIsMerchant();

  return canOpenReturn({
    uniqueReturnOnly: shop.preferences?.allowOnlyUniqueReturnRequest === true,
    isMerchant,
    returnRequests: returnRequestsData?.returnRequests ?? [],
  });
}
